import HomepageArticles from './homepage-articles.component'

export default HomepageArticles
